import { render } from "./support-chat.vue?vue&type=template&id=0e871b48&scoped=true"
import script from "./support-chat.vue?vue&type=script&lang=js"
export * from "./support-chat.vue?vue&type=script&lang=js"

import "./support-chat.vue?vue&type=style&index=0&id=0e871b48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e871b48"]])

export default __exports__